<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data().title" [subheader]="data().p1" />
  </ng-container>

  <ng-container body>
    <email-button [href]="data().button_link" [label]="data().button_text" theme="primary" />
  </ng-container>
</email-layout>
